/**
 * The client page's list row for their Messages chat (ClientMessagesTab):
 * no CSS and nothing started unless enabled, so the client page stays as it
 * was where Messages is switched off. The chat itself is ClientChatEmbed,
 * loaded only when opened.
 */
import { useEffect, useState } from 'react';
import { ensureStarted, getState, subscribe } from '../data/store';
import { previewText } from '../data/model';

export function findChat(s, clientId) {
    const ids = Object.keys(s.conversations);
    for (let i = 0; i < ids.length; i += 1) {
        const c = s.conversations[ids[i]];
        if (c.kind === 'client' && String(c.clientId) === String(clientId)) return c;
    }
    return null;
}

/**
 * For the client page's list: the chat's last message and Bailey's state.
 * Starts nothing unless enabled (MESSAGES_VISIBLE), so the client page
 * never wakes Messages where it is switched off.
 */
export function useClientChatSummary(clientId, enabled) {
    const [summary, setSummary] = useState(null);
    useEffect(() => {
        if (!enabled || !clientId) return undefined;
        ensureStarted();
        let key = '';
        const read = () => {
            const s = getState();
            const c = findChat(s, clientId);
            const list = c ? (s.messages[c.id] || []).filter((m) => !m.threadRootId && !m.note && !m.system) : [];
            const last = list.length ? list[list.length - 1] : null;
            const next = c ? { id: c.id, bailey: (c.bailey && c.bailey.state) || null, at: last ? last.createdAt : null,
                preview: last ? previewText(last, s.people, s.me && s.me.id) : '' } : null;
            const k = JSON.stringify(next);
            if (k !== key) { key = k; setSummary(next); }
        };
        read();
        return subscribe(read);
    }, [clientId, enabled]);
    return summary;
}


